import React from 'react'
import Overpanel, {
  DEFAULT_DURATION as OVERPANEL_DEFAULT_DURATION,
} from 'react-components/overpanel'
import { connect } from 'transfer/utils/p2p-connect'
import * as OverpanelActions from 'transfer/actions/overpanels'
import GenericVariant from './risk-hold-generic'
import AccountTakeoverVariant from './risk-hold-account-takeover'
import SecurityVariant from './risk-hold-security'
import PropTypes from 'prop-types'
import { VARIANTS, trackButtonClick } from 'transfer/utils/risk-hold-utils'

function Variant(props) {
  const { variant = '' } = props
  switch (variant) {
    case VARIANTS.ACCOUNT_TAKEOVER:
    case VARIANTS.ACCOUNT_TAKEOVER_WITH_AVATAR:
      return <AccountTakeoverVariant {...props} />
    case VARIANTS.SECURITY:
      return <SecurityVariant {...props} />
    default:
      return <GenericVariant {...props} />
  }
}

function RiskHoldsOverpanel(props) {
  const {
    riskHoldOverpanelVariant,
    displayName,
    recipient,
    firstName,
    lastName,
    country,
    onSubmit,
    dispatch,
    showRiskHoldsOverpanel,
  } = props

  const closeOverpanel = () => {
    dispatch(OverpanelActions.toggleRiskHoldsOverpanel({ show: false }))
  }

  const onConfirm = () => {
    trackButtonClick('continue', riskHoldOverpanelVariant)
    dispatch(OverpanelActions.onRiskHoldsConfirm())
    closeOverpanel()
    // Due to race conditions with other potential overpanels, we need to add
    // a set timeout so the screen won't freeze
    setTimeout(() => {
      onSubmit()
    }, OVERPANEL_DEFAULT_DURATION)
  }

  const onClose = () => {
    trackButtonClick('cancel', riskHoldOverpanelVariant)
    closeOverpanel()
  }

  const onCancel = () => {
    trackButtonClick('dont_send', riskHoldOverpanelVariant)
    closeOverpanel()
  }

  return (
    <Overpanel handleClose={onClose} show={showRiskHoldsOverpanel}>
      <Variant
        displayName={displayName}
        recipient={recipient}
        firstName={firstName}
        lastName={lastName}
        onConfirm={onConfirm}
        onCancel={onCancel}
        variant={riskHoldOverpanelVariant}
        country={country}
      />
    </Overpanel>
  )
}

RiskHoldsOverpanel.propTypes = {
  displayName: PropTypes.string,
  recipient: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  country: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  showRiskHoldsOverpanel: PropTypes.bool.isRequired,
  riskHoldOverpanelVariant: PropTypes.string.isRequired,
}

Variant.propTypes = {
  variant: PropTypes.string.isRequired,
}

export default connect(({ transaction, recipient, server, overpanels }) => ({
  displayName: recipient.displayName,
  recipient: recipient.recipient,
  firstName: recipient.firstName,
  lastName: recipient.lastName,
  country: server.country,
  showRiskHoldsOverpanel: overpanels.showRiskHoldsOverpanel,
  riskHoldOverpanelVariant: transaction.riskHoldOverpanelVariant,
}))(RiskHoldsOverpanel)
